import Button from '../../../../UI/Button/Button'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'

type Props = {
  uuid: string
}

const OpenPreview: React.FC<Props> = ({ uuid }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <Button className="font-bold text-lg w-full" href={`/public/survey-preview/${uuid}`} newTab contrast text={t.survey.configuration.openPreview} />
  )
}

export default OpenPreview
